import { Action, createActionGroup, emptyProps, props } from '@ngrx/store';
import { CognitoTokensWithIotConnectionInfo } from '@core/models/cognito-tokens-with-iot-connection-info';
import { GetCredentialsForIdentityResponse } from '@core/services/cognito-identity.service';
import { CallerIdentity } from '@core/iot-data/iot-data.reducer';

export const amplifyServiceActions = createActionGroup({
  source: 'AmplifyService',
  events: {
    pubSubConnectionStateUpdate: props<{ connectionState: string }>(),
  },
});

export const amplifyCredentialProviderActions = createActionGroup({
  source: 'AmplifyCredentialProvider',
  events: {
    credentialsExpiring: emptyProps(),
    clearCredentialsAndIdentityId: emptyProps(),
    forceCredentialsRefreshRequested: emptyProps(),
    userOrTenantChanged: emptyProps(),
  },
});

export const backendIotDataApiActions = createActionGroup({
  source: 'cco-backend/IoT-Data/API',
  events: {
    getFederationTokenSuccess: props<{ idToken: string }>(),
    getFederationTokenFailure: props<{ err: any }>(),
    getIotConnectionInfoSuccess: props<{ iotConnectionInfo: CognitoTokensWithIotConnectionInfo }>(),
    getIotConnectionInfoFailure: props<{ err: any }>(),
  },
});

export const cognitoIdentityApiActions = createActionGroup({
  source: 'aws/cognito-identity/API',
  events: {
    federationTokenExpired: emptyProps(),
    getIdSuccess: props<{ identityId: string }>(),
    getIdFailure: props<{ err: any }>(),
    getCredentialsForIdentitySuccess: props<{ response: GetCredentialsForIdentityResponse }>(),
    getCredentialsForIdentityFailure: props<{ err: any }>(),
  },
});

export const stsApiActions = createActionGroup({
  source: 'aws/sts/API',
  events: {
    getCallerIdentitySuccess: props<{ callerIdentity: CallerIdentity }>(),
    getCallerIdentityFailure: props<{ err: any }>(),
  },
});

export const iotDataActionGuards = {
  getIotConnectionInfoSuccess(action: Action): action is ReturnType<typeof backendIotDataApiActions.getIotConnectionInfoSuccess> {
    return action.type === backendIotDataApiActions.getIotConnectionInfoSuccess.type;
  },
  getCredentialsForIdentitySuccess(action: Action): action is ReturnType<typeof cognitoIdentityApiActions.getCredentialsForIdentitySuccess> {
    return action.type === cognitoIdentityApiActions.getCredentialsForIdentitySuccess.type;
  },
};
